import { createApiClient, responseData } from '#lib/api/client.js';

export const getPublishingCart = async (
	fetchFn: typeof globalThis.fetch,
	productIds: string[]
) =>
	responseData(
		await createApiClient(fetchFn).GET('/website-api/pages/cart/publishing', {
			params: { query: { productIds: productIds.join(',') } },
		})
	);
